namespace RedBullMOBILE360.PushNotifications {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.PushNotifications.PushNotificationsPGDialog')
    export class PushNotificationsPGDialog extends Serenity.EntityDialog<PushNotificationsPGRow, any> {
        protected getFormKey() { return PushNotificationsPGForm.formKey; }
        protected getIdProperty() { return PushNotificationsPGRow.idProperty; }
        protected getLocalTextPrefix() { return PushNotificationsPGRow.localTextPrefix; }
        protected getNameProperty() { return PushNotificationsPGRow.nameProperty; }
        protected getService() { return PushNotificationsPGService.baseUrl; }
        protected getDeletePermission() { return PushNotificationsPGRow.deletePermission; }
        protected getInsertPermission() { return PushNotificationsPGRow.insertPermission; }
        protected getUpdatePermission() { return PushNotificationsPGRow.updatePermission; }

        protected form = new PushNotificationsPGForm(this.idPrefix);
    }
}